/**
 * Menu script
 *
 * @package DZ Theme Framework
 * @license MIT
 */
class DZ_Menu {
    constructor() {
        this.initEvents();
        this.previousScroll = 0;
        this.menuTop = 0;
    }

    initEvents() {
        let self = this;
        this.menu = $('#site-navigation');
        this.button = this.menu.find('.menu-toggle');
        this.previousScroll = $(window).scrollTop();

        this.button.on('click', function(e) {
            e.preventDefault();

            if(self.button.attr('aria-expanded') === 'true') {
                self.button.attr('aria-expanded', 'false');
                $(document.body).removeClass('no-scroll');
            } else {
                self.button.attr('aria-expanded', 'true');
                $(document.body).addClass('no-scroll');
            }
        });
    }
}
